import { render, staticRenderFns } from "./AtMenuIcon.vue?vue&type=template&id=5f8958c3&scoped=true&"
import script from "./AtMenuIcon.vue?vue&type=script&lang=js&"
export * from "./AtMenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./AtMenuIcon.vue?vue&type=style&index=0&id=5f8958c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8958c3",
  null
  
)

export default component.exports